import '../dataSourceSingleGraph.less';
import { observer } from 'mobx-react';
import React from 'react';

import { WidgetConfigurationProps } from 'controls/designer/features/widgets/widgetConfig';
import { ApplicationState } from 'framework/applicationState';
import { Section } from 'controls/react/layout/section';
import { Toolbar } from 'controls/react/layout/toolbar';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput } from 'controls/react/ant/antInput';
import { AntInputNumber } from 'controls/react/ant/antInputNumber';
import { AntButton } from 'controls/react/ant/antButton';
import { PlusCircleOutlined } from '@ant-design/icons';
import { i18n } from 'core/localization';
import { AccountSelector } from 'controls/react/accountSelector';
import { TimePeriodSettingsSection } from 'controls/designer/features/widgets/datasources/shared/components/time-period-settings-section/timePeriodSettingsSection';

import { DataSourceSingleGraphWidgetConfig } from '../types';
import { DataSourceSingleGraphEditorStore } from './DataSourceSingleGraphEditorStore';
import { DataSourceRow } from './DataSourceRow';

export const DataSourceSingleGraphEditor = observer(
	class InnerConfig extends React.Component<WidgetConfigurationProps<DataSourceSingleGraphWidgetConfig>> {
		store: DataSourceSingleGraphEditorStore;

		constructor(props: WidgetConfigurationProps<DataSourceSingleGraphWidgetConfig>) {
			super(props);
			this.store = new DataSourceSingleGraphEditorStore(props);
		}

		componentDidMount() {
			this.store.init();
		}

		componentWillUnmount() {
			this.store.destroy();
		}

		render() {
			const { config } = this.props;
			const store = this.store;

			return (
				<Section appearance={'none'} childrenPadding={true}>
					<Section title={i18n('General')} appearance={'frame-top-only'} contentPadding={true} childrenPadding={true}>
						<FormEntryNew label={i18n('Name')} model={config} modelField={'title'}>
							<AntInput />
						</FormEntryNew>
						<FormEntryNew
							label={i18n('Account')}
							model={config}
							modelField={'dataSourceSelectorAccountId'}
							alwaysWithValue={true}
						>
							<AccountSelector accountId={ApplicationState.userAccountId} withSharedDatasourceOption={true} />
						</FormEntryNew>
					</Section>
					<Section
						title={i18n('Datasources')}
						appearance={'frame-top-only'}
						contentPadding={true}
						childrenPadding={true}
					>
						<Toolbar>
							<AntButton
								type={'text'}
								shape={'circle'}
								icon={<PlusCircleOutlined />}
								onClick={store.addRow}
								title={i18n('Add')}
							/>
						</Toolbar>
						{store.rows.map((row) => (
							<DataSourceRow
								key={row.requestId}
								row={row}
								canRemove={store.rows.length > 1}
								onRemove={store.removeRow}
							/>
						))}
					</Section>
					<Section
						appearance={'frame-top-only'}
						title={i18n('Display settings')}
						contentPadding={true}
						childrenPadding={true}
					>
						<FormEntryNew label={i18n('Decimal Numbers')} model={config} modelField={'decimalsNumber'}>
							<AntInputNumber min={0} max={8} />
						</FormEntryNew>
					</Section>
					<TimePeriodSettingsSection store={store} model={config} />
				</Section>
			);
		}
	},
);
